import { render, staticRenderFns } from "./unfinished.vue?vue&type=template&id=6a45551e&scoped=true&"
import script from "./unfinished.vue?vue&type=script&lang=js&"
export * from "./unfinished.vue?vue&type=script&lang=js&"
import style0 from "./unfinished.vue?vue&type=style&index=0&id=6a45551e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45551e",
  null
  
)

export default component.exports